"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSidePanel = exports.SidePanelProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _SidePanel = _interopRequireDefault(require("./SidePanel"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SidePanelContext = /*#__PURE__*/_react["default"].createContext({
  isSidePanelOpen: false,
  sidePanelContent: []
});
var SidePanelProvider = exports.SidePanelProvider = /*#__PURE__*/function (_React$Component) {
  function SidePanelProvider() {
    var _this;
    _classCallCheck(this, SidePanelProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SidePanelProvider, [].concat(args));
    _defineProperty(_this, "state", {
      isSidePanelOpen: false,
      showBackdrop: false,
      sidePanelContent: []
    });
    _defineProperty(_this, "timeout", []);
    _defineProperty(_this, "pushSidePanel", function (_ref) {
      var title = _ref.title,
        content = _ref.content,
        onClose = _ref.onClose;
      if (_this.state.isSidePanelOpen) {
        _this.setState({
          isSidePanelOpen: false,
          showBackdrop: true
        });
        _this.waitForAnimation(function () {
          return _this.addSidePanelToArray({
            title: title,
            content: content,
            onClose: onClose
          });
        });
        return;
      }
      _this.addSidePanelToArray({
        title: title,
        content: content,
        onClose: onClose
      });
    });
    _defineProperty(_this, "addSidePanelToArray", function (_ref2) {
      var title = _ref2.title,
        content = _ref2.content;
      _this.setState(function (prevState) {
        return {
          isSidePanelOpen: true,
          showBackdrop: true,
          sidePanelContent: [].concat(_toConsumableArray(prevState.sidePanelContent), [{
            title: title,
            content: content
          }])
        };
      });
    });
    _defineProperty(_this, "popSidePanel", function () {
      if (!_this.state.isSidePanelOpen || _this.state.sidePanelContent.length === 0) return;
      var lastPanel = (0, _lodash.last)(_this.state.sidePanelContent);
      if (typeof (lastPanel === null || lastPanel === void 0 ? void 0 : lastPanel.onClose) === 'function') {
        var result = lastPanel.onClose();
        if (result === false) return;
      }
      var nextSidePanelContent = _this.state.sidePanelContent.slice(0, -1);
      if (nextSidePanelContent.length) {
        _this.setState({
          isSidePanelOpen: false
        });
        _this.waitForAnimation(function () {
          return _this.setState(function (prevState) {
            return {
              isSidePanelOpen: true,
              showBackdrop: true,
              sidePanelContent: prevState.sidePanelContent.slice(0, -1)
            };
          });
        });
        return;
      }
      _this.setState({
        isSidePanelOpen: false,
        showBackdrop: false
      }, function () {
        _this.waitForAnimation(function () {
          return _this.setState({
            sidePanelContent: []
          });
        });
      });
    });
    _defineProperty(_this, "setLastPanelOptions", function (options) {
      var lastPanel = (0, _lodash.last)(_this.state.sidePanelContent);
      if (!lastPanel) return;
      var newLastPanel = _objectSpread(_objectSpread({}, lastPanel), options);
      _this.setState(function (prevState) {
        return {
          sidePanelContent: [].concat(_toConsumableArray(prevState.sidePanelContent.slice(0, -1)), [newLastPanel])
        };
      });
    });
    _defineProperty(_this, "waitForAnimation", function (callback) {
      _this.timeout.push(setTimeout(callback, 300));
    });
    _defineProperty(_this, "handleKeyDown", function (e) {
      // Close with ESC key
      if (e.keyCode === 27) {
        _this.popSidePanel();
      }
    });
    return _this;
  }
  _inherits(SidePanelProvider, _React$Component);
  return _createClass(SidePanelProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
      this.timeout.forEach(clearTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _last, _last2;
      return /*#__PURE__*/_react["default"].createElement(SidePanelContext.Provider, {
        value: {
          isSidePanelOpen: this.state.isSidePanelOpen,
          sidePanelContent: this.state.sidePanelContent,
          pushSidePanel: this.pushSidePanel,
          popSidePanel: this.popSidePanel,
          setLastPanelOptions: this.setLastPanelOptions
        }
      }, this.props.children, /*#__PURE__*/_react["default"].createElement(_SidePanel["default"], {
        showBackdrop: this.state.showBackdrop,
        isSidePanelOpen: this.state.isSidePanelOpen,
        popSidePanel: this.popSidePanel,
        title: (_last = (0, _lodash.last)(this.state.sidePanelContent)) === null || _last === void 0 ? void 0 : _last.title
      }, (_last2 = (0, _lodash.last)(this.state.sidePanelContent)) === null || _last2 === void 0 ? void 0 : _last2.content));
    }
  }]);
}(_react["default"].Component);
var withSidePanel = exports.withSidePanel = function withSidePanel(Component) {
  return /*#__PURE__*/function (_React$Component2) {
    function _class() {
      _classCallCheck(this, _class);
      return _callSuper(this, _class, arguments);
    }
    _inherits(_class, _React$Component2);
    return _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        return /*#__PURE__*/_react["default"].createElement(SidePanelContext.Consumer, null, function (sidePanelContextValue) {
          return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, _this2.props, sidePanelContextValue));
        });
      }
    }]);
  }(_react["default"].Component);
};
//# sourceMappingURL=SidePanelProvider.js.map